import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const Products = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  const products = [
    {
      title: "NotesBuddy",
      subtitle: "Notes Management Software",
      description: "Revolutionize the way you manage ideas and information. NotesBuddy uses advanced AI to simplify note-taking, boost organization, and improve knowledge retrieval.",
      logo: "/Assests/notesbuddy.png",
      link: "/notebuddy",
      features: ["AI-Assisted Note Creation", "Automatic Summaries", "Contextual Search Retrieval", "Cross-Device Sync"]
    },
    {
      title: "EasyLearn",
      subtitle: "Learning Management System",
      description: "Transform your educational institution with our comprehensive LMS platform. Manage courses, track student progress, deliver engaging content, and foster collaborative learning environments with powerful analytics and intuitive design.",
      logo: "/Assests/easylearn-logo.png",
      link: "/easylearn-lms",
      features: ["Course Management", "Student Analytics", "Interactive Content", "Assessment Tools"]
    },
    {
      title: "EasyTutor",
      subtitle: "Tutoring Software",
      description: "Revolutionize one-on-one learning experiences with our advanced tutoring platform. Schedule sessions, manage student portfolios, track progress in real-time, and deliver personalized instruction with built-in video conferencing and whiteboard tools.",
      logo: "/Assests/easytutor-logo.png",
      link: "/easytutor",
      features: ["Session Scheduling", "Video Conferencing", "Progress Tracking", "Payment Integration"]
    },
    {
      title: "Skill Master",
      subtitle: "Upskilling Software",
      description: "Empower your workforce with cutting-edge upskilling solutions. Identify skill gaps, create personalized learning paths, deliver industry-relevant training, and measure competency growth with AI-powered recommendations and certifications.",
      logo: "/Assests/Skill_Master_logo.png",
      link: "/skill-master",
      features: ["Skill Assessment", "Learning Paths", "Certifications", "Performance Analytics"]
    },
    {
      title: "Athena Star",
      subtitle: "Educational OTT Platform",
      description: "Athena Star delivers engaging educational content through movies, videos, books, and podcasts, creating an immersive and flexible learning experience.",
      logo: "/Assests/Athena-Star.png",
      link: "/athenastar",
      features: ["Interactive Learning Content", "Multi-Format Knowledge Hub", "Personalized Recommendations", "Cross-Device Streaming"]
    },
    {
      title: "ISF Academy ",
      subtitle: "Learning Management System",
      description: "ISF Academy LMS is a comprehensive and innovative e-learning platform designed for modern educational institutions. It delivers an engaging, interactive, and user-friendly digital learning experience.",
      logo: "/Assests/ISFAcademylogo.png",
      link: "/Isfacademy",
      features: ["Interactive Learning Experience", "Secure & Scalable Platform", "Easy Implementation", "Smart Academic Management"]
    },
    {
      title: "MentorBox",
      subtitle: "Project Mentoring & Management System",
      description: "MentorBox is an AI-powered mentoring and project management platform that connects individuals with expert mentors to accelerate learning, growth, and goal achievement.",
      logo: "/Assests/mentor-logo.png",
      link: "/mentorbox",
      features: ["AI-Powered Mentor Matching", "Integrated Project Management", "Real-Time Collaboration", "Progress Tracking & Insights"]
    },
    {
      title: "PitchDeck",
      subtitle: "Investor Pitch Documentation System (IPDS)",
      description: "PitchDeck is an AI-powered platform designed to streamline the creation, management, and optimization of investor pitch decks for startups and entrepreneurs.",
      logo: "/Assests/pitchdeck-logo.png",
      link: "/pitchdeck",
      features: ["Automated Pitch Deck Generation", "Intelligent Content Recommendations", "Real-Time Collaboration", "Pitch Performance Analytics"]
    }
    // {
    //   title: "BaatChit",
    //   subtitle: "Smart Video Communication Platform",
    //   description: "Connect teams, clients, and communities through secure and high-quality video conferencing designed for modern communication and collaboration.",
    //   logo: "/Assests/baatchit-logo.png",
    //   link: "/baatchit",
    //   features: ["Virtual Meetings & Webinars", "Screen Sharing & Chat", "Cross-Device Connectivity", "Secure Encrypted Calls"]
    // }

  ];

  return (
    <div className="bg-black text-white">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-8 lg:px-24 py-20 pt-32">
        <div className="max-w-7xl mx-auto">
          <div className="text-center space-y-6 z-10">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              Our EdTech Product Suite<br />for Modern Education
            </h1>
            
            <p className="text-gray-400 text-lg lg:text-xl max-w-4xl mx-auto leading-relaxed">
              Discover innovative software solutions designed to transform learning experiences, 
              enhance educational outcomes, and empower institutions with cutting-edge technology.
            </p>

            <div className="flex gap-4 justify-center pt-4">
              <button className="px-8 py-3 bg-orange-500 text-white rounded-xl font-medium hover:bg-orange-600 transition">
                Explore All Products
              </button>
              <button className="px-8 py-3 bg-transparent text-white rounded-xl font-medium hover:bg-white hover:text-black transition border-2 border-white">
                Request Demo
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="relative px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Section Heading */}
          <div className="mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Choose Your Perfect Solution
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl">
              Select the product that best fits your educational needs and start transforming your learning environment today.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {products.map((product, index) => {
              return (
                <div
                  key={index}
                  onClick={() => navigate(product.link)}
                  className="bg-black border-2 border-gray-500 rounded-2xl p-8 hover:border-orange-500 transition-all duration-300 cursor-pointer group"
                >
                  {/* Product Logo */}
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
                    style={{ backgroundColor: 'rgba(255, 255, 255, 1)' }}
                  >
                    <img 
                      src={product.logo} 
                      alt={`${product.title} Logo`}
                      className="w-10 h-10 object-contain"
                    />
                  </div>

                  {/* Title */}
                  <h4 className="text-2xl font-bold text-white mb-2">
                    {product.title}
                  </h4>

                  {/* Subtitle */}
                  <p className="text-orange-500 text-sm font-semibold mb-4">
                    {product.subtitle}
                  </p>

                  {/* Description */}
                  <p className="text-gray-400 leading-relaxed mb-6">
                    {product.description}
                  </p>

                  {/* Features List */}
                  <ul className="space-y-2 mb-6">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-gray-300 text-sm">
                        <span className="text-orange-500 mr-2">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* Learn More Link */}
                  <div className="flex items-center text-orange-500 font-semibold group-hover:text-orange-400 transition-colors">
                    <span>Learn More</span>
                    <svg
                      className="w-5 h-5 ml-2 transform group-hover:translate-x-2 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Horizontal Line */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent mb-12"></div>

          {/* Bottom CTA Section */}
          <div className="space-y-8">
            <h3 className="text-3xl lg:text-4xl font-bold text-orange-500">
              Why Choose Our Products?
            </h3>
            
            <p className="text-gray-300 text-lg leading-relaxed max-w-5xl">
              Our comprehensive EdTech suite is built on years of educational expertise and cutting-edge technology. 
              Each product is designed to address specific learning challenges while seamlessly integrating with your 
              existing systems. <b>From K-12 institutions to corporate training programs, our solutions scale with your 
              needs and deliver measurable results that transform educational outcomes.</b>
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-8">
              <button className="bg-orange-500 hover:bg-orange-600 text-black font-bold px-8 py-3 rounded-lg transition-colors duration-300">
                Schedule Demo
              </button>
              <button className="bg-transparent border-2 border-orange-500 hover:bg-orange-500/10 text-orange-500 font-bold px-8 py-3 rounded-lg transition-colors duration-300">
                Contact Sales
              </button>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Products;